import React from "react";
import MainApp from "./components/MainApp";

function App() {
  return (
    <div>
      <MainApp />
    </div>
  );
}

export default App;
